import {
  makeStyles,
  Skeleton,
  SkeletonItem,
  tokens,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { ConstrainedContent } from "../layout/ConstrainedContent";

const useClasses = makeStyles({
  skeletonRow: {
    marginBottom: tokens.spacingVerticalM,
  },
  skeletonHeader: {
    marginBottom: tokens.spacingVerticalM,
    display: "flex",
    flexDirection: "row-reverse",
    justifyContent: "space-between",
  },
  skeletonButton: {
    width: "100px",
  },
  skeletonSearch: {
    width: "300px",
  },
});

export const PublishedListSkeleton = () => {
  const classes = useClasses();
  const { t } = useTranslation();

  return (
    <ConstrainedContent>
      <Skeleton aria-label={t("loading")}>
        <div className={classes.skeletonHeader}>
          <SkeletonItem
            className={classes.skeletonSearch}
            shape="rectangle"
            size={40}
          />
        </div>
        <SkeletonItem className={classes.skeletonRow} size={40} />
        <SkeletonItem className={classes.skeletonRow} size={40} />
        <SkeletonItem className={classes.skeletonRow} size={40} />
        <SkeletonItem className={classes.skeletonRow} size={40} />
        <SkeletonItem className={classes.skeletonRow} size={40} />
        <SkeletonItem className={classes.skeletonRow} size={40} />
        <SkeletonItem className={classes.skeletonRow} size={40} />
        <SkeletonItem className={classes.skeletonRow} size={40} />
        <SkeletonItem className={classes.skeletonRow} size={40} />
        <SkeletonItem className={classes.skeletonRow} size={40} />
        <SkeletonItem className={classes.skeletonRow} size={40} />
        <SkeletonItem className={classes.skeletonRow} size={40} />
        <SkeletonItem className={classes.skeletonRow} size={40} />
        <SkeletonItem className={classes.skeletonRow} size={40} />
      </Skeleton>
    </ConstrainedContent>
  );
};
